export const TYPES = {
  SET_DEFAULT_BAILIFF_ALL: "default_bailiff/SET_DEFAULT_BAILIFF_ALL",
  SET_DEFAULT_BAILIFF_OPEN_ADD: "default_bailiff/SET_DEFAULT_BAILIFF_OPEN_ADD",
  SET_DEFAULT_BAILIFF_OPEN_EDIT:
    "default_bailiff/SET_DEFAULT_BAILIFF_OPEN_EDIT",
  SET_DEFAULT_BAILIFF_SELECTED: "default_bailiff/SET_DEFAULT_BAILIFF_SELECTED",
  SET_DEFAULT_BAILIFF_SEARCH: "default_bailiff/SET_DEFAULT_BAILIFF_SEARCH",
  SET_DEFAULT_BAILIFF_DETAIL: "default_bailiff/SET_DEFAULT_BAILIFF_DETAIL",
};
